const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id/metadata.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { generateOfferMeta } from "@/lib/generate-offer-meta";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { httpClient } from "@/lib/http-client";
import i18n from "@/lib/i18n";
import { offerOnlyQueryOptions } from "@/queries/offer-gql";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
type LoaderData = {
  dehydratedState: DehydratedState;
  id: string;
  offer: SingleOffer | null;
  locale: string | undefined;
};
export const Route = createFileRoute("/{-$locale}/offers/$id/metadata")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      queryClient,
      locale
    } = context;
    const {
      id
    } = params;
    const offer = await queryClient.ensureQueryData(offerOnlyQueryOptions(id, locale));
    await Promise.allSettled([queryClient.prefetchQuery({
      queryKey: ["sandbox", {
        id: offer?.namespace
      }],
      queryFn: () => httpClient.get<SingleSandbox>(`/sandboxes/${offer?.namespace}`).catch(() => null)
    }), queryClient.prefetchQuery({
      queryKey: ["assets", {
        id: offer?.id
      }],
      queryFn: () => httpClient.get<{
        assets: Asset;
      }[]>(`/offers/${offer?.id}/assets`).catch(() => [])
    })]);
    return {
      id,
      offer,
      locale,
      dehydratedState: dehydrate(queryClient)
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData?.dehydratedState, [...offerOnlyQueryOptions(params.id, ctx.loaderData?.locale).queryKey]);
    if (!offer) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    return {
      meta: generateOfferMeta(offer, "Metadata")
    };
  }
});

/**
 * Converts the countries codes to the names in english
 * @param countries
 * @returns
 */